<template>
  <div v-if="chapter">
    <div class="p-d-flex p-jc-between title" @click="collapsedChapter">
      <div>{{ chapter.mtcChapterName }}</div>
      <div>{{ itemsChecked }}/{{ itemsLength }}</div>
    </div>
    <p-transition-expand>
      <div v-if="chapter.Collapsed">
        <local-item
          class="item"
          v-for="(item, index) of chapter.items"
          :key="index"
          :item="item"
          :BID="BID"
          :chapterName="chapter.mtcChapterName"
          @showResultPanel="$emit('showResultPanel', $event)"
          @refreshServiceCall="$emit('refreshServiceCall', $event)"
        ></local-item>
      </div>
    </p-transition-expand>
  </div>
</template>

<script>
import LocalItem from "./item";
import PTransitionExpand from "@/components/partials/p-transition-expand";

export default {
  components: {
    LocalItem,
    PTransitionExpand,
  },
  props: {
    chapter: Object,
    BID: Number,
  },
  emits: ["collapsedChapter"],
  data() {
    return {
      //   chapterLocal: null,
    };
  },
  mounted() {
    // this.chapterLocal = this.chapter;
  },
  methods: {
    collapsedChapter() {
      this.$emit("collapsedChapter", this.chapter, !this.chapter.Collapsed);
    },    
  },
  computed: {
    itemsChecked() {
      return this.chapter.items.filter((item) => item.checkResult != 1).length;
    },
    itemsLength() {
      return this.chapter.items.length;
    },
  },
};
</script>

<style scoped>
.title {
  padding: 10px;
  background-color: #e8e8e8;
  font-weight: bold;
}

.item {
  padding: 10px;
}

.item:not(:last-child) {
  border-bottom: 1px solid #c8cacd;
}
</style>
